<template>
  <div id="page-panel" class="box grow scrollable only-y" >
    <resize-observer @notify="__resizeHanlder" />
    <profit_loss v-if="reportCode=='PROFIT_LOSS'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate"></profit_loss>
    <payments v-if="reportCode=='PAYMENTS'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></payments>
    <aging v-if="reportCode=='AGING'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></aging>
    <invoices_detail v-if="reportCode=='INVOICES_DETAIL'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></invoices_detail>
    <credits_detail v-if="reportCode=='CREDITS_DETAIL'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></credits_detail>
    <sales v-if="reportCode=='SALES'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></sales>
    <summarySalesByProduct v-if="reportCode=='SUMMARY_SALES_BY_PRODUCT'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></summarySalesByProduct>
    <summaryCustomerSalesByProduct v-if="reportCode=='SUMMARY_CUSTOMER_SALES_BY_PRODUCT'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></summaryCustomerSalesByProduct>
    <summaryProductsPurchasedByCustomer v-if="reportCode=='SUMMARY_PRODUCTS_PURCHASED_BY_CUSTOMER'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></summaryProductsPurchasedByCustomer>
    <gl v-if="reportCode=='GL'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></gl>
    <salesIntent v-if="reportCode=='SALES_INTENT'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></salesIntent>
    <wineSales v-if="reportCode=='WINE_SALES'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></wineSales>
    <wineCustomerSales v-if="reportCode=='WINE_CUSTOMER_SALES'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></wineCustomerSales>
    <wineRepSales v-if="reportCode=='WINE_SALES_REP'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></wineRepSales>
    <wineSalesProductPerformance v-if="reportCode=='PERFORMANCE_PRODUCT'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></wineSalesProductPerformance>
    <wineSalesProductsPerformance v-if="reportCode=='PERFORMANCE_PRODUCTS'" :width="this.pageWidth" :companyName="portausCompanyName" :fiscalEndDay="portausEndFiscalDay" :fiscalEndMonth="portausEndFiscalMonth" :lastFiscalYearDate="lastFiscalYearDate" :fiscalYearDate="fiscalYearDate" :month="month" :lastMonth="lastMonth"></wineSalesProductsPerformance>
    <purchaseOrdersForecast v-if="reportCode=='PURCHASE_ORDERS_FORECAST'" :width="this.pageWidth" :companyName="portausCompanyName"></purchaseOrdersForecast>
    <inventoryProductsValorization v-if="reportCode=='INVENTORY_PRODUCTS_VALORIZATION'" :width="this.pageWidth" :companyName="portausCompanyName"></inventoryProductsValorization>
    <commissionReport v-if="reportCode=='COMMISSION'" :width="this.pageWidth" ></commissionReport>
    <repReservationsReport v-if="reportCode=='REP_RESERVATION_ALLOCATIONS'" :width="this.pageWidth" ></repReservationsReport>
  </div>
</template>
<script>

import profit_loss from './components/profit_loss'
import payments from './components/payments'
import aging from './components/aging'
import gl from './components/gl'
import invoices_detail from './components/invoices_detail'
import credits_detail from './components/credits_detail'
import salesIntent from './components/intents'
import sales from './components/sales'
import wineSales from './components/wine-sales'
import wineCustomerSales from './components/wine-customer-sales'
import wineRepSales from './components/wine-rep-sales'
import wineSalesProductPerformance from './components/wine-sales-product-performance';
import wineSalesProductsPerformance from './components/wine-sales-products-performance';
import purchaseOrdersForecast from './components/purchase-orders-forecast';
import inventoryProductsValorization from './components/inventory-products-valorization';
import commissionReport from './components/commission';
import repReservationsReport from './components/rep-reservations-report';
import summarySalesByProduct from './components/summary-sales-by-product';
import summaryCustomerSalesByProduct from './components/summary-customer-sales-by-product';
import summaryProductsPurchasedByCustomer from './components/summary-products-purchased-by-customer';

import moment from 'moment'

import { mapGetters } from 'vuex';

export default {
  name : "report",
  props : {

  },
  data() {
    return {
      pageWidth : null,
      pageHeight : null,
    };
  },
  components : {
    profit_loss,
    payments,
    aging,
    invoices_detail,
    sales,
    credits_detail,
    salesIntent,
    gl,
    wineSales,
    wineSalesProductPerformance,
    wineSalesProductsPerformance,
    purchaseOrdersForecast,
    inventoryProductsValorization,
    wineCustomerSales,
    wineRepSales,
    commissionReport,
    repReservationsReport,
    summarySalesByProduct,
    summaryCustomerSalesByProduct,
    summaryProductsPurchasedByCustomer
  },
  computed : {
    companyName(){
      if (localStorage.CIE_INFO == null) return null;
      return _.get(JSON.parse(localStorage.CIE_INFO), 'name');
    },
    fiscalEndDay(){
      if (localStorage.CIE_INFO == null) return null;
      return _.get(JSON.parse(localStorage.CIE_INFO), 'fiscalEndDay');
    },
    fiscalEndMonth(){
      if (localStorage.CIE_INFO == null) return null;
      return _.get(JSON.parse(localStorage.CIE_INFO), 'fiscalEndMonth');
    },
    reportCode(){
      return this.$route.params.code;
    },
    lastFiscalYearDate(){
      let lastFiscalYearDate = {};
      let fiscalYearDate = this.fiscalYearDate;
      if(fiscalYearDate.startDate!=null && fiscalYearDate.endDate!=null){
        let startDate = moment(fiscalYearDate.startDate,'DD MMM YYYY').subtract(1,'year');
        let endDate = moment(fiscalYearDate.endDate,'DD MMM YYYY').subtract(1,'year');
        lastFiscalYearDate = {startDate, endDate}
      }

      return lastFiscalYearDate;
    },
    fiscalYearDate(){
      let fiscalYearDate = {};
      if(this.portausCompanyEndFiscalDay!=null && this.portausCompanyEndFiscalMonth!=null){
        let endDate = null;
        if(moment().format('M')>this.portausCompanyEndFiscalMonth){
          endDate = moment(this.portausCompanyEndFiscalMonth.toString()+'-'+this.portausCompanyEndFiscalDay.toString(),'MM-DD').add(1,'year');
        }else{
          endDate = moment(this.portausCompanyEndFiscalMonth.toString()+'-'+this.portausCompanyEndFiscalDay.toString(),'MM-DD');
        }
        let startDate = moment(endDate).subtract(1, 'year').add(1,'day');
        fiscalYearDate = {startDate, endDate};
      }
      return fiscalYearDate
    },
    month(){
      return {startDate : moment().startOf('month'), endDate : moment().endOf('month')}
    },
    lastMonth(){
      return {startDate : moment().subtract(1,'months').startOf('month'), endDate : moment().subtract(1,'months').endOf('month')}
    },
    ...mapGetters(['portausCompanyName', 'portausCompanyEndFiscalMonth', 'portausCompanyEndFiscalDay']),
  },
  methods : {
		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700)
  },
  mounted(){
    this.setPageWidth();
  },
  created(){

  }
}
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';





.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
